import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
  flowViewContainer: {
    paddingTop: '40px',
    display: 'flex',
    alignItems: 'flex-start',
    paddingLeft: '10px',
    '@media (max-width: 768px)': {
      paddingRight: '10px',
    },
  },
  flowViewContainerContent: {
    display: 'flex',
    margin: '0 auto',
    gap: '40px',
    '@media (max-width: 768px)': {
      flexDirection: 'column-reverse',
      maxWidth: '100%',
    },
  },
});
